import { render, staticRenderFns } from "./PurchaseInvoicePaymentList.vue?vue&type=template&id=4cb110ad&scoped=true&"
import script from "./PurchaseInvoicePaymentList.vue?vue&type=script&lang=js&"
export * from "./PurchaseInvoicePaymentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb110ad",
  null
  
)

export default component.exports